export const CATEGORIES = [
  { slug: "weird-science", name: "Weird Science", color: "emerald", chip: "bg-paper text-ink border-gold" },
  { slug: "bizarre-history", name: "Bizarre History", color: "amber", chip: "bg-amber-50 text-amber-700 border-amber-200" },
  { slug: "cosmic-mysteries", name: "Cosmic Mysteries", color: "violet", chip: "bg-paper text-ink border-gold" },
  { slug: "nature-creatures", name: "Nature & Creatures", color: "lime", chip: "bg-lime-50 text-lime-700 border-lime-200" },
  { slug: "mind-glitches", name: "Mind Glitches", color: "cyan", chip: "bg-cyan-50 text-cyan-700 border-cyan-200" },
  { slug: "unbelievable-tech", name: "Unbelievable Tech", color: "rose", chip: "bg-rose-50 text-rose-700 border-rose-200" },
];

export const catBySlug = (slug) => CATEGORIES.find((c) => c.slug === slug) || { name: slug, chip: "bg-slate-100 text-ink border-slate-200" };
